import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import Cards from "../components/ServiceCard";
import CounselingFormModal from "../components/CounselingFormModal";
import SliderCard from "../components/Slider";
import FAQ from "../components/Faq";
import Testimonials from "../components/Testimonial";
import AOS from "aos";
import "aos/dist/aos.css";
// Import your global JSON data
import globalData from "../json/home.json";
const BASE_URI = process.env.REACT_APP_API_BASE_URI;
export const Home = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // Destructure the data from the imported JSON
  const {
    pageTitle,
    hero,
    cardData,
    faqSection,
    testimonials,
    counselingSection,
    GetKnowUs,
    BlogData,
    Services,
  } = globalData;

  // API Services state
  const [apiServices, setApiServices] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(true);
  const [servicesError, setServicesError] = useState("");

  const [apiTestimonials, setApiTestimonials] = useState([]);
  const [testimonialsLoading, setTestimonialsLoading] = useState(true);
  const [testimonialsError, setTestimonialsError] = useState("");

  // Blog API state
  const [apiBlogs, setApiBlogs] = useState([]);
  const [blogsLoading, setBlogsLoading] = useState(true);
  const [blogsError, setBlogsError] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = pageTitle;
    AOS.init({
      duration: 800,
      once: false,
    });
    fetchServices();
    fetchTestimonials();
  }, [pageTitle]);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };
  // Fetch services
  const fetchServices = async () => {
    try {
      setServicesLoading(true);
      const res = await axios.get(
        `${BASE_URI}/entities?category=service`,
        getAuthHeaders(),
      );

      if (res.data && res.data.data) {
        const transformedData = res.data.data.map((item) => ({
          id: item.id,
          image:
            item.data.images && item.data.images.length > 0
              ? item.data.images[0]
              : null,
          title: item.data.title,
          description: item.data.description,
          button_text: item.data.button_text,
        }));

        setApiServices(transformedData);
      } else {
        console.warn("Unexpected API response structure:", res.data);
        setApiServices(cardData);
      }
      setServicesError("");
    } catch (err) {
      console.error("Error fetching services", err);
      setServicesError("Failed to load services");
      setApiServices(cardData);
    } finally {
      setServicesLoading(false);
    }
  };

  // Fetch testimonials
  const fetchTestimonials = async () => {
    try {
      setTestimonialsLoading(true);
      const res = await axios.get(
        `${BASE_URI}/entities?category=testimonial`,
        getAuthHeaders(),
      );

      if (res.data && res.data.data) {
        const transformedData = res.data.data.map((item) => ({
          id: item.id, // The unique ID from the outer object
          image:
            item.data.images && item.data.images.length > 0
              ? item.data.images[0]
              : null, // Safely access the first image
          text: item.data.text,
          name: item.data.name,
        }));

        setApiTestimonials(transformedData);
      } else {
        console.warn("Unexpected API response structure:", res.data);
        // Fallback to JSON data if API response is unexpected
        setApiTestimonials(testimonials.data);
      }
      setTestimonialsError("");
    } catch (err) {
      console.error("Error fetching testimonials", err);
      setTestimonialsError("Failed to load testimonials");
      // Fallback to JSON data if API fails
      setApiTestimonials(testimonials.data);
    } finally {
      setTestimonialsLoading(false);
    }
  };

  // Fetch blogs
  // Updated fetchBlogs function
  const fetchBlogs = async () => {
    try {
      setBlogsLoading(true);
      const res = await axios.get(
        `${BASE_URI}/entities?category=blog`,
        getAuthHeaders(),
      );

      if (res.data && res.data.data) {
        // Check if data array is empty
        if (res.data.data.length === 0) {
          setApiBlogs([]);
          setBlogsError("");
          return;
        }

        const transformedData = res.data.data.map((item) => ({
          id: item.id,
          image:
            item.data.images && item.data.images.length > 0
              ? item.data.images[0]
              : null,
          title: item.data.title,
          description: item.data.description,
          content: item.data.content,
          created_at: item.data.created_at,
          updated_at: item.data.updated_at,
        }));

        // Sort by creation date (most recent first) and take only 4
        const sortedBlogs = transformedData
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .slice(0, 4);

        setApiBlogs(sortedBlogs);
      } else {
        console.warn("Unexpected API response structure:", res.data);
        // Set empty array instead of fallback to JSON data
        setApiBlogs([]);
      }
      setBlogsError("");
    } catch (err) {
      console.error("Error fetching blogs", err);
      setBlogsError("Failed to load blogs");
      // Set empty array instead of fallback to JSON data
      setApiBlogs([]);
    } finally {
      setBlogsLoading(false);
    }
  };

  // Blog Card Skeleton Loading Component
  const BlogCardSkeleton = () => (
    <div className="col-md-6 col-12 d-flex justify-content-center mb-4">
      <div className="our-blogs-card">
        <div
          className="our-blog-card-image"
          style={{
            backgroundColor: "#f0f0f0",
            height: "200px",
            borderRadius: "8px",
            background:
              "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
          }}
        />
        <div className="our-blog-card-content pt-4">
          <div
            style={{
              width: "80%",
              height: "24px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              marginBottom: "10px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
            }}
          />
          <div>
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                style={{
                  width: i === 2 ? "70%" : "100%",
                  height: "16px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  background:
                    "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.5s infinite",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // Testimonial Skeleton Loading Component
  const TestimonialSkeleton = () => (
    <div className="col-lg-4 col-md-6 col-12 mb-4">
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "20px",
          height: "100%",
          background: "#fff",
        }}
      >
        {/* Profile image skeleton */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              backgroundColor: "#f0f0f0",
              borderRadius: "50%",
              marginRight: "15px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
            }}
          />
          <div>
            {/* Name skeleton */}
            <div
              style={{
                width: "120px",
                height: "20px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "5px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
              }}
            />
            {/* Title skeleton */}
            <div
              style={{
                width: "80px",
                height: "16px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
              }}
            />
          </div>
        </div>

        {/* Text skeleton */}
        <div>
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              style={{
                width: i === 3 ? "60%" : "100%",
                height: "16px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "8px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );

  // Service Card Skeleton Loading Component
  const ServiceCardSkeleton = () => (
    <div className="col-12 col-sm-6 col-md-4 mb-4 main-card-box">
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "20px",
          height: "100%",
          width: "100%",
          background: "#fff",
        }}
      >
        {[200, 24, 16, 16, 16, 36].map((h, i) => (
          <div
            key={i}
            style={{
              width:
                i === 0 ? "100%" : i === 1 ? "80%" : i === 5 ? "100px" : "100%",
              height: `${h}px`,
              borderRadius: "4px",
              marginBottom: i === 0 ? "15px" : "8px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
            }}
          />
        ))}
      </div>
    </div>
  );

  const [index, setIndex] = useState(0);
  const { runningWords } = hero;

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % runningWords.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [runningWords.length]);

  const [banners, setBanners] = useState([]);

  const fetchBanners = async (page = 1) => {
    try {
      const res = await axios.get(
        `${BASE_URI}/entities?category=banner`,
        getAuthHeaders(),
      );

      if (res.data && res.data.data) {
        const transformedData = res.data.data.map((item) => ({
          id: item.id,
          images: item.data.images || [],
        }));

        setBanners(transformedData);
      } else {
        setBanners([]);
      }
    } catch (err) {
      console.error("Error fetching banners", err);
      setBanners([]);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchBanners();
    fetchBlogs();
  }, []);
  // Helper function to truncate text
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  // Helper function to handle blog click
  const handleBlogClick = (blogId) => {
    navigate(`/blogs`);
  };
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>

      <section className="banner fixed-padding side-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-6 hero-div">
              <div className="hero-content">
                <div className="top">
                  <div className="Heading-Wrapper">
                    <div className="text-container">
                      <h1>{hero.heading}</h1>
                    </div>
                    <div
                      className="running-text pb-2"
                      data-aos="fade-up"
                      data-aos-duration="2000"
                    >
                      <span key={index} className="animated-word">
                        {runningWords[index]}
                      </span>
                    </div>
                  </div>
                  <div
                    className="hero-text"
                    data-aos="fade-up"
                    data-aos-duration="3000"
                  >
                    <div className="supproting-text">
                      <p>{hero.subheading}</p>
                    </div>
                    <div
                      className="supporting-buttons d-flex"
                      data-aos="fade-up"
                      data-aos-duration="3000"
                    >
                      <div className="navigate-button">
                        <Button
                          variant="default"
                          className="hero-btn-primary"
                          onClick={() => navigate("/services")}
                        >
                          See Services
                        </Button>
                      </div>
                      <div className="connect-button">
                        <Button
                          variant="outline"
                          className="hero-btn-secondary"
                          onClick={() => setShowModal(true)}
                        >
                          Book an Appointment{" "}
                          <i className="bi bi-telephone"></i>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="testimonials"
                  data-aos="fade-up"
                  data-aos-duration="3000"
                >
                  <div className="avatars">
                    <a href="#testimonial" className="avatars__item">
                      <img className="avatar" src="/testi-img4.jpg" alt="" />
                    </a>
                    <a href="#testimonial" className="avatars__item">
                      <img className="avatar" src="/hero-img2.avif" alt="" />
                    </a>
                    <a href="#testimonial" className="avatars__item">
                      <img className="avatar" src="/testi-img1.jpg" alt="" />
                    </a>
                    <a href="#testimonial" className="avatars__item">
                      <img className="avatar" src="/testi-img3.jpg" alt="" />
                    </a>
                  </div>
                  <div className="text-wrapper d-flex">
                    <div className="star">
                      <img src="/star.png" alt="" />
                    </div>
                    <div className="text">
                      <p>4.9 Average Rating From 300+ Happy Students</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6">
              <div className="hero-images">
                <div className="decor-wraper1">
                  <div className="cube"></div>
                  <div className="hero-image1">
                    <img src="hero-img1.avif" alt="" />
                  </div>
                </div>
                <div className="decor-wraper2">
                  <div className="row right-row">
                    <div className="hero-right-img">
                      <img src="/hero-img2.avif" alt="" />
                    </div>
                    <div className="cube2"></div>
                  </div>
                  <div className="hero-img-main">
                    <img src="/hero-img-main.avif" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-pd">
        <div className="container">
          <SliderCard
            images={banners.flatMap((b) => b.images)}
            customClass="home-slider"
          />
        </div>
      </section>

      {/* services section */}
      <section className="services section-pd">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="service">
                <div className="heading-wrapper text-center">
                  <div className="heading mb-3">
                    <h2>{Services.Heading}</h2>
                  </div>
                  <div className="service-text">
                    <p>{Services.text}</p>
                  </div>
                </div>

                {/* Error Message */}
                {servicesError && (
                  <div className="alert alert-warning" role="alert">
                    {servicesError} - Showing default services
                  </div>
                )}

                <div className="row g-4 justify-content-center">
                  {/* Show skeleton loading */}
                  {servicesLoading ? (
                    <>
                      {Array.from({ length: 3 }).map((_, index) => (
                        <ServiceCardSkeleton key={index} />
                      ))}
                    </>
                  ) : (
                    // Show actual services
                    apiServices.map((service, idx) => (
                      <div
                        key={service.id || idx}
                        className="col-12 col-md-6 col-lg-4 card-box main-card-box"
                      >
                        <Cards
                          image={service.image}
                          title={service.title}
                          description={service.description}
                          buttonText={service.button_text}
                          onGetQuote={() => setShowModal(true)}
                        />
                      </div>
                    ))
                  )}
                </div>

                <div className="go-to-services text-center mt-5">
                  <Button
                    variant="default"
                    onClick={() => navigate("/services")}
                  >
                    See All Services <i className="bi bi-arrow-right"></i>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Blog Section - Now with API */}
      <section className="our-blogs">
        <div className="container">
          {/* Heading Section */}
          <div className="our-blogs-heading text-center pb-3">
            <h2>{BlogData.heading}</h2>
            <p>{BlogData.text}</p>
          </div>

          {/* Error Message */}
          {blogsError && (
            <div className="alert alert-warning" role="alert">
              {blogsError}
            </div>
          )}

          {/* Show skeleton loading, no blogs message, or actual blogs */}
          {blogsLoading ? (
            <div className="row">
              {Array.from({ length: 2 }).map((_, index) => (
                <BlogCardSkeleton key={index} />
              ))}
            </div>
          ) : apiBlogs.length === 0 ? (
            // No blogs available message
            <div className="row">
              <div className="col-12">
                <div className="text-center py-5">
                  <div className="mb-3">
                    <i
                      className="bi bi-journal-x"
                      style={{ fontSize: "3rem", color: "#6c757d" }}
                    ></i>
                  </div>
                  <h4 className="text-muted">No blogs available</h4>
                  <p className="text-muted">
                    Check back later for new blog posts.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Blog Row 1 */}
              <div className="row">
                {apiBlogs.slice(0, 2).map((blog, index) => (
                  <div
                    key={blog.id || index}
                    className="col-md-6 col-12 d-flex justify-content-center mb-4"
                  >
                    <div
                      className="our-blogs-card"
                      onClick={() => handleBlogClick(blog.id)}
                    >
                      <div className="our-blog-card-image">
                        <img
                          src={blog.image || "/default-blog.jpg"}
                          alt={blog.title}
                          className="img-fluid"
                          onError={(e) => {
                            e.target.src = "/default-blog.jpg";
                          }}
                        />
                      </div>
                      <div className="our-blog-card-content pt-4">
                        <h2>{blog.title}</h2>
                        <p>{truncateText(blog.description, 150)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Blog Row 2 */}
              <div className="row">
                {apiBlogs.slice(2, 4).map((blog, index) => (
                  <div
                    key={blog.id || index + 2}
                    className="col-md-6 col-12 d-flex justify-content-center mb-4"
                  >
                    <div
                      className="our-blogs-card"
                      onClick={() => handleBlogClick(blog.id)}
                    >
                      <div className="our-blog-card-image">
                        <img
                          src={blog.image || "/default-blog.jpg"}
                          alt={blog.title}
                          className="img-fluid"
                          onError={(e) => {
                            e.target.src = "/default-blog.jpg";
                          }}
                        />
                      </div>
                      <div className="our-blog-card-content pt-4">
                        <h2>{blog.title}</h2>
                        <p>
                          {index === 0 ? (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: truncateText(blog.description, 150),
                              }}
                            />
                          ) : (
                            truncateText(blog.description, 150)
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Read More Button - Only show if there are blogs */}
          {!blogsLoading && apiBlogs.length > 0 && (
            <div className="go-to-services text-center mt-5">
              <button
                type="button"
                className="btn btn-outline-primary service-btn"
                onClick={() => navigate("/blogs")}
              >
                Read More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Get to know us section */}
      <section className="get-to-know-us">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-6 about-left d-flex justify-content-center">
              <div className="about-img-wrapper">
                <img src="/get-us-know.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 about-right">
              <div className="about-content">
                <div className="about-top">
                  <div className="subhead">
                    <p>{GetKnowUs.topHeading}</p>
                  </div>
                  <div className="main-head">
                    <h2>{GetKnowUs.heading}</h2>
                  </div>
                </div>
              </div>
              <div className="about-info">
                <p>{GetKnowUs.text}</p>
              </div>
              <FAQ
                faqs={faqSection.faqs}
                icons={faqSection.icons}
                bgColor="rgb(241, 245, 255)"
              />
            </div>
          </div>
        </div>
      </section>

      {/* testimonial section */}
      <section className="testimonial" id="testimonial">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="testimonial-heading mb-5">
                <h2>{testimonials.Heading}</h2>
              </div>
            </div>
          </div>

          {/* Error Message */}
          {testimonialsError && (
            <div className="alert alert-warning" role="alert">
              {testimonialsError} - Showing default testimonials
            </div>
          )}

          <div className="row">
            {/* Show skeleton loading */}
            {testimonialsLoading ? (
              <>
                {Array.from({ length: 2 }).map((_, index) => (
                  <TestimonialSkeleton key={index} />
                ))}
              </>
            ) : (
              // Show actual testimonials
              apiTestimonials.map((testimonial, idx) => (
                <Testimonials
                  key={testimonial.id || idx}
                  image={testimonial.image}
                  text={testimonial.text}
                  name={testimonial.name}
                />
              ))
            )}
          </div>
        </div>
      </section>

      {/* Free Counseling Section */}
      <section className="book-free-counseling">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="bfc-top d-flex justify-content-center">
                <div className="image-container">
                  <div className="logo-cont">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="image">
                    <img src={counselingSection.image} alt="Counseling" />
                  </div>
                </div>
              </div>
              <div className="bfc-heading mt-4 text-center">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: counselingSection.heading,
                  }}
                ></h2>
              </div>
              <div className="bfc-supporting-text mt-3 text-center">
                <p>{counselingSection.text}</p>
              </div>
              <div className="bfc-buttons text-center mt-5">
                <button
                  type="button"
                  className="btn btn-primary bfc-btn"
                  onClick={() => setShowModal(true)}
                >
                  {counselingSection.button}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CounselingFormModal
        open={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
